import tippy from 'tippy.js';

tippy.setDefaultProps({
  arrow: true,
  animation: 'fade',
  duration: ['100', '200'],
  theme: 'cobot',
});

export default function enableTippy() {
  Array.from(document.querySelectorAll('[data-tippy]')).forEach(function (el) {
    var content = el.dataset.tippy;
    if (content) {
      tippy(el, { content: content });
    }
  });
}
